"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
const request_1 = require("./request");
const defaultOptions = {
    version: 'v1',
    userAgent: 'ranna-ts',
    auth: null,
};
/**
 * Request client to perform API requests with.
 */
class Client extends request_1.RequestClient {
    /**
     * Initialize a new client connected to the passed ranna
     * server endpoint.
     *
     * You can specify additional options like the API version
     * (default 'v1'), the user agent header or the authorization
     * header, if required.
     *
     * @param endpoint The ranna server endpoint.
     * @param options Additional options.
     */
    constructor(endpoint, options = defaultOptions) {
        super(endpoint, options);
    }
    /**
     * Request the available spec map.
     * @returns SpecMap
     */
    spec() {
        return this.request('GET', 'spec');
    }
    /**
     * Execute code.
     * @param req Execution request
     * @returns Execution response
     */
    exec(req, bypassCache = false) {
        return this.request('POST', `exec?bypass_cache=${bypassCache}`, req);
    }
    /**
     * Request service information.
     * @returns
     */
    info() {
        return this.request('GET', 'info');
    }
}
exports.Client = Client;
